import type { IGenreMetadata, IMainGenre } from '@intelligence/types/common';

export interface IRobloxGenreLabel {
  en: string;
  cn: string;
}

export type TRobloxGenreLabelMap = Map<string, IRobloxGenreLabel>;

const appendGenreMetadataToMap = (
  labelMap: TRobloxGenreLabelMap,
  metadata?: IGenreMetadata | null,
): void => {
  const genreKey = metadata?.genre;

  if (!genreKey) {
    return;
  }

  labelMap.set(genreKey, {
    en: metadata.genre_en || genreKey,
    cn: metadata.genre_cn || genreKey,
  });
};

export const buildRobloxGenreLabelMap = (
  robloxGenreOptions: IMainGenre[] = [],
): TRobloxGenreLabelMap => {
  const labelMap: TRobloxGenreLabelMap = new Map();

  robloxGenreOptions.forEach((item) => {
    appendGenreMetadataToMap(labelMap, item?.main_genre);
    (item?.sub_genre || []).forEach((subGenre) => {
      appendGenreMetadataToMap(labelMap, subGenre);
    });
    (item?.level_3_genre || []).forEach((level3Genre) => {
      appendGenreMetadataToMap(labelMap, level3Genre);
    });
    (item?.level_4_genre || []).forEach((level4Genre) => {
      appendGenreMetadataToMap(labelMap, level4Genre);
    });
  });

  return labelMap;
};

export const getRobloxGenreLocalizedLabel = (
  genreKey: string | undefined | null,
  labelMap: TRobloxGenreLabelMap,
  isChinese: boolean,
): string => {
  const normalizedKey = String(genreKey || '').trim();

  if (!normalizedKey) {
    return '';
  }

  const label = labelMap.get(normalizedKey);

  if (!label) {
    return normalizedKey;
  }

  return isChinese ? label.cn : label.en;
};

export const formatRobloxTableGenreLabel = (
  genreKey: string | undefined | null,
  labelMap: TRobloxGenreLabelMap,
  isChinese: boolean,
  placeholder = '-',
): string => {
  const localizedLabel = getRobloxGenreLocalizedLabel(genreKey, labelMap, isChinese);

  return localizedLabel || placeholder;
};
